import { render } from "./BtnComp.vue?vue&type=template&id=5b686c2e"
import script from "./BtnComp.vue?vue&type=script&lang=js"
export * from "./BtnComp.vue?vue&type=script&lang=js"

import "./BtnComp.vue?vue&type=style&index=0&id=5b686c2e&lang=css"

import exportComponent from "C:\\Users\\stage\\NetttFormApp\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__